<template>
  <div class="mx-5 mx-md-16 px-md-16">
    <v-data-table
      :headers="headers"
      :items="orders.items"
      :page.sync="page"
      :items-per-page="itemsPerPage"
      :search="search"
      hide-default-footer
      class="elevation-1 rounded-lg"
      @page-count="pageCount = $event"
    >
      <template v-slot:item.actions="{ item }">
        <v-btn icon @click="activeOrder(item)"
          ><v-icon small color="success">fa-sync-alt</v-icon></v-btn
        >
      </template>
    </v-data-table>
    <div class="pt-2 d-flex flex-column flex-md-row align-center justify-end">
      <span class="font-quicksand">Filas por páginas: </span>
      <span style="width: 50px" class="mx-md-2">
        <v-select
          v-model="itemsPerPage"
          :items="itemsPerPages"
          class="font-quicksand"
        ></v-select>
      </span>
      <span class="font-quicksand"
        >1-{{ itemsPerPage }} de {{ orders.totalItems }}</span
      >
      <v-pagination
        v-model="page"
        :length="pageCount"
        :total-visible="pageVisible"
        color="red"
        class="font-work-sans"
      ></v-pagination>
    </div>

    <order-dialog
      :order="order"
      :del="del"
      :dialog="dialog"
      @dismiss="
        () => {
          dialog = false
          loadData()
        }
      "
    />
  </div>
</template>

<script>
import Repository from '@/repositories/RepositoryFactory'
const OrderRepository = Repository.get('orders')
import OrderDialog from './Dialog.vue'
import format from 'date-fns/format'

export default {
  components: { OrderDialog },
  name: 'InactiveOrders',
  props: ['search'],
  data: () => ({
    orders: {},
    itemsPerPage: 7,
    pageVisible: 5,
    page: 1,
    pageCount: 0,
    headers: [
      {
        text: 'Id',
        align: 'center',
        class:
          'primary white--text rounded-tl-lg font-weight-bold text-subtitle-2',
        value: 'id',
      },
      {
        text: 'Paciente',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'patient',
      },
      {
        text: 'Fecha',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'dateNew',
      },
      {
        text: 'Doctor',
        align: 'center',
        class: 'primary white--text font-weight-bold text-subtitle-2',
        value: 'doctorName',
      },
      {
        text: 'Opciones',
        align: 'center',
        class:
          'primary white--text rounded-tr-lg font-weight-bold text-subtitle-2',
        value: 'actions',
      },
    ],
    itemsPerPages: [7, 10, 20, 30, 50, 100],
    del: false,
    order: null,
    dialog: false,
  }),
  mounted: async function () {
    await this.loadData()
  },
  methods: {
    loadData: async function () {
      this.$eventBus.emit('loading-page')
      try {
        const res = await OrderRepository.getDeleted()
        this.orders = res.data.data
        this.orders.items = Array.from(
          this.orders.items,
          ({ date, patient, ...order }) => ({
            dateNew: format(new Date(date), 'dd-MM-yyyy'),
            patient: `${patient.firstName} ${patient.lastName}`,
            date,
            ...order,
          })
        )
      } catch (error) {
        if (error.response?.status === 401) {
          localStorage.removeItem('user')
          location.reload()
        }

        const response = error.response ? error.response.data.message : error

        console.log(response)
      }
    },
    activeOrder: function (item) {
      this.order = item
      this.dialog = true
    },
  },
}
</script>
